export default __webpack_public_path__ + "static/media/header.fe2f2542.jpg";